export default __webpack_public_path__ + "static/media/auto.7c434df1.svg";